import type MP4Box from 'mp4box';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateVideoType = (info: MP4Box.Mp4BoxInfo, allowMoreVideoCodecs: boolean, addError: AddError): void => {
  const supportedVideoTypes = ['avc1'];
  const moreSupportedVideoTypes = ['avc1', 'av01', 'hev1', 'hvc1'];
  const types = allowMoreVideoCodecs ? moreSupportedVideoTypes : supportedVideoTypes;

  let supportedVideoType = false;

  for (const type of types) {
    if (!info.videoTracks[0].codec) {
      continue;
    }

    if (info.videoTracks[0].codec.toLowerCase().indexOf(type) > -1) {
      supportedVideoType = true;
      break;
    }
  }

  if (!supportedVideoType) {
    addError(VALIDATIONS.INVALID_FORMAT);
  }
};

export default validateVideoType;
